import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/dispensacao-materiais`

    return {
        create(id) {
            return repository.get(`${baseUrl}/create/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        print(id) {
            return repository.get(`${baseUrl}/dispensacao/${id}`)
        },
        getHistorico(id, params) {
            return repository.get(`${baseUrl}/historico/${id}`, params)
        }
    }
}